import { render, staticRenderFns } from "./deletePorder.vue?vue&type=template&id=0982b506&scoped=true&"
import script from "./deletePorder.vue?vue&type=script&lang=js&"
export * from "./deletePorder.vue?vue&type=script&lang=js&"
import style0 from "./deletePorder.vue?vue&type=style&index=0&id=0982b506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982b506",
  null
  
)

export default component.exports